import React from "react";
import HomeGoogleMapGlobal from "./HomeGoogleMapGlobal";
import "./HomeSlider.css";

const globalWebsite = [
  {
    id: "1",
    link: "https://miraic-global.jp/china/",
    title: "China (Shanghai / Beijing / Shenzhen)",
  },
  {
    id: "2",
    link: "https://miraic-global.jp/vietnam/",
    title: "Vietnam (Ho Chi Minh/Hanoi)",
  },
  {
    id: "3",
    link: "https://miraic-global.jp/malaysia/",
    title: "Malaysia",
  },
  {
    id: "4",
    link: "https://miraic-global.jp/singapore/",
    title: "Singapore",
  },
  {
    id: "5",
    link: "https://miraic-global.jp/thailand/",
    title: "Thailand",
  },
];

const globalOffice = [
  {
    id: "1",
    title: "Main Office",
    address:
      "19th floor, Kyobashi Edogrand, 2-2-1 Kyobashi, Chuo-ku, Tokyo 104-0031",
  },
  {
    id: "2",
    title: "Asahikawa Branch Office",
    address:
      "8F Ichijo Midoribashi-dori Building, 542-4 Ichijo-dori 8-chome, Asahikawa City, 070-0031",
  },
  {
    id: "3",
    title: "Sapporo Branch Office",
    address:
      "Sapporo MN Building 5F, 3-3 Kita 1-jo Nishi, Chuo-ku, Sapporo 060-0001",
  },
  {
    id: "4",
    title: "Hachinohe Branch Office",
    address:
      "〒031-0042 Hachinohe City Jusankamachi 1 Via Nova Building 3rd floor",
  },
  {
    id: "5",
    title: "Akita Branch Office",
    address:
      "〒010-0002 Akita Base Center Alve 2nd floor Atelier Alve II, 4-1 Higashidori Nakamachi Akita City",
  },
  {
    id: "6",
    title: "Morioka Branch Office",
    address:
      "〒020-0033 1-10 Hashiichi Morioka Building 4F, Morioka Station Kitadori, Morioka City",
  },
  {
    id: "7",
    title: "Sendai Branch Office",
    address: "〒980-0021 JMF Sendai 01 2nd floor, 4-10-3 Chuo, Aoba-ku, Sendai",
  },
  {
    id: "8",
    title: "Fukushima Branch Office",
    address:
      "2nd floor, Corasse Fukushima, 1-20 Mikawaminamimachi, Fukushima City, 960-8053",
  },
  {
    id: "9",
    title: "Niigata Branch Office",
    address:
      "9F Nippon Life Insurance Niigata Building, 2-4-10 Higashi-Odori, Chuo-ku, Niigata City, 950-0087",
  },
  {
    id: "10",
    title: "Toyama Branch Office",
    address:
      "2nd floor, Toyama Electric Building, 3-1 Sakurabashi-dori, Toyama City, 930-0004",
  },
  {
    id: "11",
    title: "Saitama Branch Office",
    address:
      "Address: 3-13-1 Nakacho, Omiya-ku, Saitama-shi, Saitama 330-0845, Japan. Sumitomo Life Omiya 2nd Building, 3rd floor",
  },
  {
    id: "12",
    title: "Kawagoe Branch Office",
    address: "〒350-0063 Kawagoe City Saiwai-cho 4-1",
  },
  {
    id: "13",
    title: "Shibuya Stadium",
    address:
      "〒150-0043 Tokyo, Shibuya-ku, Dogenzaka 1-19-9 Daiichi Akatsuki Building 4F",
  },
  {
    id: "14",
    title: "Tachikawa Branch Office",
    address:
      "TAMA MIRAI SQUARE 2-8-28 Akebono-cho, Tachikawa-shi, Tokyo 190-0012",
  },
  {
    id: "15",
    title: "Yokohama Branch Office",
    address:
      "〒220-0004 1-5-10 Kitasaiwai, Nishi-ku, Yokohama, Kanagawa Prefecture, JPR Yokohama Building 9F, Expert Office Yokohama, Room 713",
  },
  {
    id: "16",
    title: "Hamamatsu Branch Office",
    address:
      "100-1 Kajicho, Chuo-ku, Hamamatsu City, 430-0933, Japan Zaza City, Hamamatsu Central Building B1F",
  },
  {
    id: "17",
    title: "Nagoya Branch Office",
    address:
      "2nd Floor, Okaya Koki Building, 2-4-18 Sakae, Naka-ku, Nagoya 460-0008",
  },
  {
    id: "18",
    title: "Kyoto Branch Office",
    address:
      "〒600-8413 Kyoto City Shimogyo Ward Karasuma-dori Bukkoji-shita 680-1 Omasacho-cho Daihachi Hase Building 2F",
  },
  {
    id: "19",
    title: "Osaka Branch Office",
    address:
      "12th floor, Midosuji MTR Building, 3-6-3 Awajicho, Chuo-ku, Osaka 541-0047",
  },
  {
    id: "20",
    title: "Setouchi Branch Office",
    address:
      "〒700-0903 8-20 Saiwai-cho, Kita-ku, Okayama City, Okayama Prefecture, AQUA Terrace Saiwai-cho 6th floor",
  },
  {
    id: "21",
    title: "Matsue Branch Office",
    address: "〒690-0845 40-1 Nishichamachi, Matsue City, Enun 2nd Floor",
  },
  {
    id: "22",
    title: "Kitakyushu Branch Office",
    address:
      "1-1-1 Asano, Kokurakita-ku, Kitakyushu-shi, 802-0001, Japan. 1st floor, DISCOVERY coworking, Room 112, Viera Kokura",
  },
  {
    id: "23",
    title: "Fukuoka Branch Office",
    address: "〒812-0012 Fukuoka City, Fukuoka Prefecture",
  },
  {
    id: "24",
    title: "Oita Branch Office",
    address:
      "〒870-0026 2-1-10 Kanaike-cho, Oita City, Oita Station, 4th floor, Walker Building",
  },
  {
    id: "25",
    title: "Okinawa Branch Office",
    address: "〒900-0015 Naha City Kumoji 1-1-1 Palette Kumoji 9th floor",
  },
];

const officeDetails = [
  {
    id: "1",
    title: "Hong Kong S.A.R",
    address:
      "Lian Da, Liu Ouyang (Hong Kong) Accountant Office Co., Ltd. (Reanda)",
  },
  {
    id: "2",
    title: "Taiwan",
    address: "利安達平合計師事務所 (Reanda)",
  },
  {
    id: "3",
    title: "United States (America)",
    address: "Oishi & Company",
  },
  {
    id: "4",
    title: "Vietnam",
    address: "Hankyu Mirai Business Partners Vietnam Co., Ltd.",
  },
  {
    id: "5",
    title: "Thailand",
    address: "FDI Group, MSNA Group",
  },
  {
    id: "6",
    title: "Singapore",
    address: "Adept PAC (Reanda)",
  },
  {
    id: "7",
    title: "India",
    address: "Udyen Jain & Associates, Ashok Maheshwary & Associates LLP",
  },
  {
    id: "8",
    title: "Nepal",
    address: "Reanda Biz Serve Pvt. Ltd.",
  },
  {
    id: "9",
    title: "Sri Lanka",
    address: "Kreston MNS & Co.",
  },
];

const doubledGlobal = [...officeDetails, ...officeDetails, ...officeDetails];

const HomeGlobalThree = () => {
  return (
    <div>
      <div className="lg:relative hidden-on">
        <div className="w-full  bgService custom-polygon"></div>

        <div className="w-full h-[850px]  p-10 max-w-screen-2xl  rounded bg-white shadow-md absolute top-[35%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-10">
          <h1 className="text-5xl font-semibold font-jost customBlue">
            Global Network
          </h1>
          <div className="overflow-hidden h-[700px] mt-10 card-overlay">
            <div className="gap-5 grid grid-cols-1 mt-10 animate-slide-reverseGlobal">
              {doubledGlobal.map((global, index) => (
                <div
                  key={index}
                  className="w-full flex bg-blue-50 hover:animate-pulse duration-300 ease-in-out flex-col items-start rounded-xl border lg:py-6 sm:py-2 lg:px-4 sm:px-2 relative "
                >
                  <h1 className="text-xl font-semibold font-jost customBlue">
                    {global.title}
                  </h1>
                  <h1 className="text-md font-jost text-blue-900 mt-3">
                    <strong>Address:</strong> {global.address}
                  </h1>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="w-full  relative z-0">
          <HomeGoogleMapGlobal />
        </div>
      </div>

      <div className="lg:hidden px-4  py-10 ">
        <h1 className="text-xl font-semibold font-jost customBlue">
          Global Network
        </h1>
        {/* <p className="mt-2 font-jost text-lg text-blue-900">Global Branches</p> */}
        <div className="grid grid-cols-1 gap-2 my-6">
          {officeDetails.map((global) => (
            <a href={global.link} target="_blank">
              <div className="w-full flex flex-col  bg-blue/20 backdrop-blur-sm/30 backdrop-blur-sm   hover:animate-pulse duration-300 ease-in-out  justify-between item-start rounded border border-blue-200 py-1 px-2">
                <h1 className="text-sm font-jost customBlue  ">
                  {global.title}
                </h1>
                <p className="text-sm font-jost text-gray-500  ">
                  Address {global.address}
                </p>
              </div>
            </a>
          ))}
        </div>
        <div className="map-container">
          <HomeGoogleMapGlobal />
        </div>
      </div>
    </div>
  );
};

export default HomeGlobalThree;
